import React, { useReducer } from "react";
import { RestfulProvider } from "restful-react";
import { userReducer, LOGIN, LOGOUT, initialState } from "./Reducer";
import { AuthInfoProps, GlobalContextProps, Identity } from "../types";

const loginInit = (token: string): void => {
  return;
};

const logoutInit = (): void => {
  return;
};

export const authInfoContext = React.createContext<GlobalContextProps>({
  authInfo: initialState,
  login: loginInit,
  logout: logoutInit
});

function getAuthInfo(): AuthInfoProps | null {
  const token = localStorage.getItem("authInfo");
  if (token) {
    // parse token
    return {
      loggedIn: true,
      userId: 1,
      identity: Identity.ROOT,
      // accessCode: 0b01111111,
      accessCode: 0b011111111,
      expires: 99999999999
    };
  }
  return null;
}

const GlobalState = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [authInfo, dispatch] = useReducer(
    userReducer,
    getAuthInfo() || initialState
  );

  const login = (token: string): void => {
    dispatch({ type: LOGIN, token });
  };

  const logout = (): void => {
    dispatch({ type: LOGOUT });
  };

  return (
    <authInfoContext.Provider
      value={{
        authInfo,
        login,
        logout
      }}
    >
      <RestfulProvider base={process.env.REACT_APP_DOMAIN as string}>
        {children}
      </RestfulProvider>
    </authInfoContext.Provider>
  );
};

export default GlobalState;
